import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const NoArticle = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Frame">
        <g id="Group">
          <path
            id="Vector"
            d="M91.6425 53.336C90.687 51.4744 90.2298 49.397 90.3155 47.3062C90.4012 45.2154 91.0269 43.1824 92.1316 41.4052L94.7215 37.2389L70.7379 22.3303L68.1481 26.4966C67.0433 28.2738 65.4971 29.7346 63.6602 30.7368C61.8232 31.739 59.758 32.2485 57.6656 32.2156C55.5733 32.1826 53.5081 32.6921 51.6711 33.6943C49.8341 34.6965 48.288 36.1573 47.1832 37.9345L15.3047 89.2179C15.8937 89.344 16.5375 89.4164 17.2552 89.4164C24.4622 89.4164 24.4622 82.3566 31.669 82.3566C38.8758 82.3566 38.8758 89.4164 46.0828 89.4164C53.2894 89.4164 53.2894 82.3566 60.4962 82.3566C67.7032 82.3566 67.7032 89.4164 74.91 89.4164C75.3649 89.4164 75.791 89.3881 76.192 89.3353L91.1534 65.2669C92.2581 63.4897 92.8838 61.4567 92.9695 59.3659C93.0552 57.2751 92.5981 55.1977 91.6425 53.336Z"
            fill="#CCE7FE"
          />
          <path
            id="Vector_2"
            d="M2.84375 110.596C10.0505 110.596 10.0505 117.656 17.2571 117.656C24.4641 117.656 24.4641 110.596 31.6712 110.596C38.878 110.596 38.878 117.656 46.085 117.656C53.2916 117.656 53.2916 110.596 60.4984 110.596C67.7054 110.596 67.7054 117.656 74.9122 117.656C82.1192 117.656 82.1192 110.596 89.3265 110.596C96.534 110.596 96.534 117.656 103.741 117.656C110.949 117.656 110.949 110.596 118.156 110.596M2.84375 96.4764C10.0505 96.4764 10.0505 103.536 17.2571 103.536C24.4641 103.536 24.4641 96.4764 31.6712 96.4764C38.878 96.4764 38.878 103.536 46.085 103.536C53.2916 103.536 53.2916 96.4764 60.4984 96.4764C67.7054 96.4764 67.7054 103.536 74.9122 103.536C82.1192 103.536 82.1192 96.4764 89.3265 96.4764C96.534 96.4764 96.534 103.536 103.741 103.536C110.949 103.536 110.949 96.4764 118.156 96.4764"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M66.7422 19.844L71.7115 11.8493L103.69 31.7266L98.7211 39.7212L66.7422 19.844Z"
            fill="white"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g id="Vector_4">
            <path
              d="M95.6948 26.7595L79.7057 16.8204L83.1627 2.34375L107.146 17.2523L95.6948 26.7595ZM38.4297 85.451L62.6901 46.4213C65.0929 42.5595 70.1713 41.3733 74.0331 43.7738C77.8973 46.1766 79.0834 51.255 76.6806 55.1191L59.732 82.387"
              fill="#CCE7FE"
            />
            <path
              d="M38.4297 85.451L62.6901 46.4213C65.0929 42.5595 70.1713 41.3733 74.0331 43.7738C77.8973 46.1766 79.0834 51.255 76.6806 55.1191L59.732 82.387M95.6948 26.7595L79.7057 16.8204L83.1627 2.34375L107.146 17.2523L95.6948 26.7595Z"
              stroke="#686869"
              strokeWidth="3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            id="Vector_5"
            d="M71.5571 58.7943C75.9871 57.7607 78.7404 53.3316 77.7069 48.9016C76.6733 44.4716 72.2442 41.7182 67.8142 42.7518C63.3842 43.7854 60.6309 48.2145 61.6644 52.6445C62.698 57.0745 67.1271 59.8278 71.5571 58.7943Z"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_6"
            d="M2.84375 82.3566C10.0505 82.3566 10.0505 89.4164 17.2571 89.4164C24.4641 89.4164 24.4641 82.3566 31.6712 82.3566C38.878 82.3566 38.878 89.4164 46.085 89.4164C53.2916 89.4164 53.2916 82.3566 60.4984 82.3566C67.7054 82.3566 67.7054 89.4164 74.9122 89.4164C82.1192 89.4164 82.1192 82.3566 89.3265 82.3566C96.534 82.3566 96.534 89.4164 103.741 89.4164C110.949 89.4164 110.949 82.3566 118.156 82.3566"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

NoArticle.displayName = 'NoArticle';
